/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
/* eslint-disable @typescript-eslint/camelcase */
import React, { Fragment } from 'react'
import DistChart from './ChartComponents/Distribution'
import Donut from './ChartComponents/Donut'
import PropTypes from 'prop-types'
import VestibularIcon from '../../../assets/icons/balance/balance_vestibular_system.svg'
import VisualIcon from '../../../assets/icons/balance/balance_visual_system.svg'
import ProprioceptiveIcon from '../../../assets/icons/balance/balance_proprioceptive_system.svg'
import List from '../../../components/List'
import DownCarot from '../../../assets/icons/carat.svg'

class Balance extends React.Component {
  constructor(props) {
    super(props)

    // getinitialState
    this.state = {
      balance: this.BalanceData(),
      perf: this.PerfData()
    }
  }

  UNSAFE_componentWillReceiveProps() {
    this.setState({
      balance: this.BalanceData(),
      perf: this.PerfData()
    })
  }

  BalanceData() {
    const { details } = this.props
    let stats = details.score

    return {
      display_label: stats.display_label,
      unit: stats.unit,
      value: stats.value,
      interpretation: stats.interpretation,
      percentile: stats.percentile,
      ranges: stats.ranges,
      test_name: stats.test_name,
      density_plot: stats.density_plot
    }
  }

  PerfData() {
    let { details } = this.props
    let data = details.percent_performance

    if (
      !data.proprioceptive_system.__ok ||
      !data.vestibular_system.__ok ||
      !data.visual_system.__ok
    ) {
      data.proprioceptive_system.value = 25
      data.vestibular_system.value = 25
      data.visual_system.value = 50
    }

    return {
      chartData: [
        {
          value: data.proprioceptive_system.value,
          label: data.proprioceptive_system.display_label
        },
        {
          value: data.vestibular_system.value,
          label: data.vestibular_system.display_label
        },
        {
          value: data.visual_system.value,
          label: data.visual_system.display_label
        }
      ]
    }
  }

  render() {
    const { index, details, hotload } = this.props

    const items = {
      physicalActivity: {
        title: '<h2 class="mobile-padding">Balance</h2>',
        icon: { src: DownCarot },
        isShowAccordianOnMobile: true,
        accordianContent: `
      <div class="mobile-padding">
            <div>
              <p class="noMarginPadding">
                 Balance is the ability to orient the body in space and maintain an
            upright posture under both static and dynamic conditions.
            <br />
            <br />
            Over half of accidental deaths among the elderly are the result of
            balance-related falls.
              </p>
            </div>
              <br/>
          </div>`
      }
    }
    const listProps = {
      items,
      isMobile: this.props.isMobile,
      isNoTopBorder: true,
      isNotSpacer: true,
      isCollapsedDark: true,
      isReportStyle: true
    }

    return (
      <div className="balance-content module-content">
        <div className="intro-zone">
          {this.props.isMobile ? (
            <List {...listProps} />
          ) : (
            <p style={{ marginBottom: '20px' }}>
              Balance is the ability to orient the body in space and maintain an
              upright posture under both static and dynamic conditions.
              <br />
              <br />
              Over half of accidental deaths among the elderly are the result of
              balance-related falls.
            </p>
          )}
          {!this.props.isMobile && (
            <div className="mobile-padding">
              <div className="intro-title">
                Three systems contribute to balance performance:
              </div>

              <div className="intro-flex-balance">
                <div className="intro-title">
                  <img src={VisualIcon} />
                  {!this.props.isMobile && <br />}
                  <span className="intro-title-strong">The Visual System</span>
                  <br />
                  provides information about the body’s orientation and motion
                  in space.
                </div>
                <div className="intro-title">
                  <img src={VestibularIcon} />
                  {!this.props.isMobile && <br />}
                  <span className="intro-title-strong">
                    {' '}
                    The Vestibular System
                  </span>
                  <br />
                  in the inner ear senses gravity, and linear and rotational
                  movement.
                </div>

                <div className="intro-title">
                  <img src={ProprioceptiveIcon} />
                  {!this.props.isMobile && <br />}
                  <span className="intro-title-strong">
                    {' '}
                    The Proprioceptive System
                  </span>
                  <br />
                  is a network of receptors in the muscles, joints, and skin
                  that senses how the body and limbs are positioned relative to
                  one another.
                </div>
              </div>
            </div>
          )}
        </div>

        {hotload ? (
          <div className="mobile-padding">
            {!this.props.isMobile && (
              <Fragment>
                <br />
                <br />
                <hr />
              </Fragment>
            )}
            <div className="bucket score-bucket">
              <div className="table">
                <strong className="subject">
                  {details.score.display_label}
                </strong>
                <br />
                <br />
                <div className="trow dominant">
                  <div className="td even-width balance-score">
                    <strong className="value">{details.score.value}</strong>
                    <span className="descriptor">Score</span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.score.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td balance-chart">
                    <DistChart
                      label={'BalanceDist'}
                      details={details}
                      index={index}
                      data={this.state.balance}
                    />
                  </div>
                </div>
              </div>
              {!details.score.__ok ? (
                <div className="no-report-data">
                  {`No ${details.score.display_label} Data Available`}
                </div>
              ) : null}
            </div>
            <hr />
            <br />

            <strong className="subject">Percent Performance</strong>
            <div className="bucket chart-bucket">
              <Donut
                details={details}
                index={index}
                data={this.state.perf}
                indentifier={'BalancePerf'}
              />
              {!details.score.__ok ? (
                <div className="no-report-data">
                  {`No ${details.score.display_label} Data Available`}
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
        {this.props.isMobile && (
          <div className="intro-zone mobile-padding">
            {/* <hr />
            <br />
            <div className="intro-title">
              Three systems contribute to balance performance:
            </div>
          */}

            <div className="intro-flex-balance">
              <div className="intro-title">
                <img src={VisualIcon} />
                {!this.props.isMobile && <br />}
                <span className="intro-title-strong">The Visual System</span>
                <br />
                provides information about the body’s orientation and motion in
                space.
              </div>
              <div className="intro-title">
                <img src={VestibularIcon} />
                {!this.props.isMobile && <br />}
                <span className="intro-title-strong">
                  {' '}
                  The Vestibular System
                </span>
                <br />
                in the inner ear senses gravity, and linear and rotational
                movement.
              </div>

              <div className="intro-title">
                <img src={ProprioceptiveIcon} />
                {!this.props.isMobile && <br />}
                <span className="intro-title-strong">
                  {' '}
                  The Proprioceptive System
                </span>
                <br />
                is a network of receptors in the muscles, joints, and skin that
                senses how the body and limbs are positioned relative to one
                another.
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

Balance.propTypes = {
  details: PropTypes.object.isRequired
}

export default Balance
